import guards from '../guards.js';

const load = (page) => {
  return() => import(`@/pages/${page}/${page}.vue`);
}
const nodeEnv =  window.configs && window.configs.NODE_ENV !== "" 
? window.configs.NODE_ENV: process.env.NODE_ENV;
const candidateRoutes = {
  path: '/candidate/:company',
  component: () => import(`@/layouts/CandidateLayout/CandidateLayout.vue`),
  meta: {
    isCompanySwitchingZone: true,
    zone: 'candidate',
  },
  beforeEnter: guards.restrictAccesstoUnauthorizedUsers,
  children: [
    {
      name: 'candidate-home',
      path: '',
      component: load('Profile'),
    },
    {
      name: 'candidate-profile',
      path: 'profil-candidat',
      component: load('Profile'),
    },
    {
      name: 'candidate-browse-missions',
      path: 'jobs-candidat',
      component: load('Missions'),
    },
    {
      name: 'candidate-mission',
      path: 'mission-exemple-candidat',
      component: load('Mission'),
    },
    {
      name: 'candidate-applications',
      path: 'candidatures-candidat',
      component: load('Applications'),
      beforeEnter: guards.restrictForUnconfirmedEmails,
    },
    {
      name: 'candidate-job-offer-details',
      path: 'offre-emploi-details',
      component: load('JobOfferDetails'),
    },
    {
      name: 'candidate-assignment-offer',
      path: 'assignment-offers',
      component: load('AssignmentOffers'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'candidate-assignment-offer-detail',
      path: 'assignment-offers-detail',
      component: load('AssignmentOfferDetail'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'candidate-agency',
      path: 'agence',
      component: () => import(`@/pages/Agency/AgencyContainer.vue`),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'candidate-documents',
      path: 'documents',
      meta: {
        exAdv: true
      },
      component: load('Documents'),
      beforeEnter: guards.restrictForExADVAccount,
    },
    {
      name: 'candidate-news',
      path: 'actualites',
      component: load('News'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'candidate-reclamation',
      path: 'reclamation',
      component: load('Reclamation'),
      beforeEnter: function (to, from, next) { nodeEnv !== 'development' ? next('/') : next() },
    },
    {
      name: 'candidate-support-technique',
      path: 'support-technique',
      component: load('SupportTechnique'),
    },
  ],
};

export default candidateRoutes;
